import script from "./PrimaryButtonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryButtonLoader.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryButtonLoader.vue?vue&type=style&index=0&id=26869bac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26869bac"]])

export default __exports__